import { useSagaAuth } from "@einride/saga-core"
import { Logger } from "./logging"

export function getActiveSpaceName(auth: ReturnType<typeof useSagaAuth>): string {
  const activeSpaceName = auth?.activeSpace?.name

  if (!activeSpaceName) {
    Logger.info(`${auth?.user?.uid} doesn't have an ative space`)
  }

  return activeSpaceName
}

export function getActiveOrganization(auth: ReturnType<typeof useSagaAuth>): string {
  const activeOrganization = auth?.activeOrganization?.name

  if (!activeOrganization) {
    Logger.info(`${auth?.user?.uid} doesn't have an active organization`)
  }

  return activeOrganization
}

export function getActiveOrganizationDisplayName(auth: ReturnType<typeof useSagaAuth>): string {
  const activeOrganizationName = auth?.activeOrganization?.name
  const activeOrg = auth.organizations?.find((org) => org.name === activeOrganizationName)

  if (!activeOrganizationName || !activeOrg) {
    Logger.info(`${auth?.user?.uid} doesn't have an active organization`)
  }

  return activeOrg?.displayName ?? ""
}
